// extracted by mini-css-extract-plugin
export default {"river":"river__river--1RItT"};